import $ from 'jquery';
import { orderCreate } from "../queries";

$('#orderBtn').on('click', function () {

if ($('[name="delivery_type"]:checked').val() === 'pvz' && !$('.page-order-map').hasClass('page-order-map--selected')) {
    // alert('Выберите пункт выдачи');
    $(`.ui-modal[data-name="warning2"]`).trigger('show');
    return;
}
if (!$('.page-order-panel__fio').length) {
    $(`.ui-modal[data-name="warning3"]`).trigger('show');
   }

})

$('.js-form-order').on('ui-submit', async function () {
    if ($('[name="delivery_type"]:checked').val() === 'pvz' && !$('.page-order-map').hasClass('page-order-map--selected')) {
        // alert('Выберите пункт выдачи');
        $(`.ui-modal[data-name="warning"]`).trigger('show');
        $(this).trigger('success');
        return;
    }

    // if ($('[name="delivery_type"]:checked').val() === 'courier') {
    //     if (!$('[name="delivery_courier_address"]').attr('data-value')) {
    //         $(`.ui-modal[data-name="warning"]`).trigger('show');
    //         $(this).trigger('success');
    //         return;
    //     }
    // }
    const lastNameInput = $(`input[name="another-last-name"]`);
    const nameInput = $(`input[name="another-name"]`);
    const telInput = $(`input[name="another-tel"]`);

    if ($('input[name=is-another-person-order]').is(':checked')) {
        // Проверка заполненности полей
        // if (lastNameInput.val() === '') {
        //     lastNameInput.addClass('is-invalid');
        //     lastNameInput.closest('.ui-form-control').append('<div class="ui-form-control-another__error just-validate-error-label">Заполните поле</div>');
        //     return false;
        // } else {
        //     data.set('another-last-name', lastNameInput.val());
        // }
        //
        // if (nameInput.val() === '') {
        //     nameInput.addClass('is-invalid');
        //     nameInput.closest('.ui-form-control').append('<div class="ui-form-control-another__error just-validate-error-label">Заполните поле</div>');
        //     return false;
        // } else {
        //     data.set('another-name', nameInput.val());
        // }
        //
        // if (telInput.val() === '') {
        //     telInput.addClass('is-invalid');
        //     telInput.closest('.ui-form-control').append('<div class="ui-form-control-another__error just-validate-error-label">Заполните поле</div>');
        //     return false;
        // } else {
        //     data.set('another-tel', telInput.val());
        // }
        // if (telInput.val().length !== 18) {
        //     telInput.addClass('is-invalid');
        //     telInput.closest('.ui-form-control').append('<div class="ui-form-control-another__error just-validate-error-label">Невалидный формат телефона</div>');
        //     return false;
        // } else {
        //     data.set('another-tel', telInput.val());
        // }
        // if (lastNameInput.val()) {
        //     $(this)[0].setCustomValidity('');
        // } else {
        //     $(this)[0].setCustomValidity('Укажите фамилию получателя');
        // }
    }

    const response = await orderCreate($(this).serializeJSON());
    if (!response.isSuccess) {
        $(this).trigger('error', response.error);
        if (response.error === 'Пожалуйста, добавьте адрес доставки.'){
            $(`.ui-form__error`).text('');
            $(`.ui-modal[data-name="warning"]`).trigger('show');
        }
        return;
    }
    ym(56412904, 'reachGoal', 'order-create')
    setTimeout(() => {
        window.location = `/order/proceed?id=${response.order.id}`;
    }, 300);
});
